/**
 * AppointmentInfoModal
 *
 * Bir randevuyu salt-okunur olarak gösteren modal sarmalayıcı.
 * Mevcut AppointmentFullDetailView bileşenini, MusteriServisKaydiTabModal
 * üzerinden açılan ikinci seviye modal olarak kullanır.
 */
import React, { useEffect, useState } from 'react';
import { sanitizeString } from '../utils/security';
import {
  fetchAppointmentDetailed,
  fetchAssignmentHistory,
  fetchServiceRecordDetail,
} from '../services/serviceRecordsService';
import AppointmentFullDetailView from './AppointmentFullDetailView';

const safe = (v) => sanitizeString(v ?? '');

const AppointmentInfoModal = ({ appointmentId, servisKaydiId, onClose }) => {
  const [appointment, setAppointment] = useState(null);
  const [serviceRecord, setServiceRecord] = useState(null);
  const [assignmentHistory, setAssignmentHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!appointmentId) return;
      setLoading(true);
      setError('');
      try {
        const [aptRes, histRes, srRes] = await Promise.all([
          fetchAppointmentDetailed(appointmentId).catch(() => null),
          fetchAssignmentHistory(appointmentId).catch(() => null),
          servisKaydiId ? fetchServiceRecordDetail(servisKaydiId).catch(() => null) : Promise.resolve(null),
        ]);
        if (cancelled) return;
        const apt = aptRes?.veri?.randevu || aptRes?.veri || aptRes || null;
        const hist = histRes?.veri?.atamaGecmisi || histRes?.veri?.assignmentHistory || histRes?.veri || [];
        const sr = srRes?.veri?.servisKaydi || srRes?.veri || null;
        setAppointment(apt);
        setAssignmentHistory(Array.isArray(hist) ? hist : []);
        setServiceRecord(sr);
      } catch (err) {
        if (cancelled) return;
        setError(err?.message || 'Randevu yüklenemedi');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [appointmentId, servisKaydiId]);

  if (!appointmentId) return null;

  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{ zIndex: 1100 }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '1100px',
          width: '95%',
          maxHeight: '92vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className="modal-header" style={{ flexShrink: 0 }}>
          <h2>
            <i className="fas fa-calendar-day" style={{ marginRight: 8, color: '#2563eb' }}></i>
            Randevu Detayı
          </h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body" style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
          {loading ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
              <i className="fas fa-spinner fa-spin" style={{ fontSize: 24, marginRight: 8 }}></i>
              Yükleniyor...
            </div>
          ) : error ? (
            <div style={{ padding: '20px', color: '#b91c1c', background: '#fee2e2', borderRadius: '8px' }}>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: 8 }}></i>
              {safe(error)}
            </div>
          ) : !appointment ? (
            <div style={{ padding: '20px', textAlign: 'center', color: '#64748b' }}>Randevu bulunamadı.</div>
          ) : (
            <AppointmentFullDetailView
              appointment={appointment}
              serviceRecord={serviceRecord}
              assignmentHistory={assignmentHistory}
            />
          )}
        </div>
        <div className="modal-footer" style={{ flexShrink: 0 }}>
          <button type="button" className="secondary-btn" onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppointmentInfoModal;
